import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './en/translation.json'; // Example English translation
import translationSRB from './srb/translation.json'; // Example Spanish translation

const resources = {
    en: {
        translation: translationEN
    },
    sr: {
        translation: translationSRB
    }
};

i18n.use(initReactI18next)
.init({
    resources,
    lng: 'en', // Default language
    interpolation: {
        escapeValue: false // React already safes our values
    }
});

export default i18n;
